import { RECEIVE_TOKEN } from "../constants/actionTypes";
import initialState from "./initialState";

export default function tokenReducer(state = initialState.token, action) {
  switch (action.type) {
    case RECEIVE_TOKEN:
      return action.token;
    default:
      return state;
  }
}
